
namespace TabAurous.Scheme {

    @Serenity.Decorators.registerClass()
    export class SchemeEnrollmentGrid extends Serenity.EntityGrid<SchemeEnrollmentRow, any> {
        protected getColumnsKey() { return 'Scheme.SchemeEnrollment'; }
        protected getDialogType() { return SchemeEnrollmentDialog; }
        protected getIdProperty() { return SchemeEnrollmentRow.idProperty; }
        protected getInsertPermission() { return SchemeEnrollmentRow.insertPermission; }
        protected getLocalTextPrefix() { return SchemeEnrollmentRow.localTextPrefix; }
        protected getService() { return SchemeEnrollmentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}